var path = '/templates/projects.campaigns/views/directives/campaign_chisq_test.html';
var html = "<div class=zc-alert role=alert ng-if=!chisq_test><i class=\"fa fa-lock\"></i> {{ 'projectsCampaignsViews.directives.campaignChisqTest.konogo_aida_no' | translate }}</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.campaigns/views/directives/campaign_chisq_test.html
// module id = 1357
// module chunks = 0